import { GalleryItem, RangeSettings, Settings } from 'sofa-reborn-react';

import { parseGalleryItems } from '../../../util/ProductParser';
import ThunksUtil from '../utils/ThunksUtil';
import { ProductService, KompisDefaultFields } from '@inter-ikea-kompis/services';

import { IProduct } from '@inter-ikea-kompis/types';

export default class GalleryItemsParser {
	public async parse(
		config: unknown,
		useLocalIds: boolean,
		fetchedProducts: IProduct[],
		state: unknown
	): Promise<GalleryItem[]> {
		const galleryItems = parseGalleryItems(config);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const settings = (state as any).settings.settings as Settings;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const rangeSettings: RangeSettings = (config as any).settings.settings as RangeSettings;
		const productService = new ProductService({
			locale: settings.locale,
			localizationPrefixApplication: settings.localizationPrefixApplication,
			localizationEndpoints: settings.localizationEndpoints,
		});
		return [...galleryItems].filter((item) => {
			const prod = fetchedProducts.find(
				(prod) => item.productItem.id === ThunksUtil.getProductItemId(prod, useLocalIds)
			);
			return (
				prod &&
				prod.content &&
				prod.content['child'] &&
				prod.content['child'].every((child) =>
					fetchedProducts.some(async (product) => {
						if (
							(rangeSettings.localSofabedMattressId &&
								Object.values(rangeSettings.localSofabedMattressId as object).includes(
									child.itemId.slice(4)
								)) ||
							(rangeSettings.localSofabedMattressId &&
								Object.values(rangeSettings.newLocalSofabedMattressId as object).includes(
									child.itemId.slice(4)
								))
						) {
							const mattresses = await productService.getProducts(
								[{ type: 'ART', id: child.itemId.slice(4) }],
								KompisDefaultFields
							);

							if (mattresses.length > 0) {
								return mattresses[0];
							}
						}
						return (
							child.itemId === product.itemId ||
							child.itemId.slice(4) === product.content?.itemNoLocal
						);
					})
				)
			);
		});
	}
}
